import { useState } from 'react';
import { useParams } from "react-router-dom";
import classNames from 'classnames';
import close from '../../assets/images/close.png';
import styles from './OfflineDonateModal.module.css';
import { submitOfflineDonationApi } from "../../api/fundraisers";
import Button from '../Button.jsx';
import FormInput from "../form/FormInput";
import FormButton from "../form/FormButton";
import FormError from "../form/FormError";
import FormDonateMoneyInput from "../form/FormDonateMoneyInput";

const OfflineDonateModal = (props) => {
    const { fundraiserId } = useParams();
    const [formData, setFormData] = useState({
        amount: '',
        displayName: ''
    });
    const initialErrorObject = {
        amount: false
    };
    const [errorObject, setErrorObject] = useState(initialErrorObject);
    const inputsMessagesErrorObject = {
        amount: 'Not a valid amount',
    };
    const [submissionInProgress, setSubmissionInProgress] = useState(false);

    const updateDonationAmount = (event) => {
		const isNoMoreThanTwoDecimals = event.target.value.match(/^(\d*\.{0,1}\d{0,2}$)/);
		if(isNoMoreThanTwoDecimals){
			setFormData({...formData, amount: event.target.value});
		}
	};

    const checkForEmptyInputs = () => {
        setErrorObject(initialErrorObject);
        const newErrorObject = structuredClone(initialErrorObject);
        let foundError = false;
        for(const key of Object.keys(formData)){
            if(key !== 'displayName' && !formData[key]){
                newErrorObject[key] = inputsMessagesErrorObject[key];
                foundError = true;
            }
        }
        setErrorObject(newErrorObject);
        return foundError;
    };

    const submit = async(event) => {
        event.preventDefault();
        setErrorObject(initialErrorObject);
        setSubmissionInProgress(true);
        if(checkForEmptyInputs()){
            setSubmissionInProgress(false);
            return;
        }
        const submitOfflineDonationResponse = await submitOfflineDonationApi(fundraiserId, formData.amount, formData.displayName);
        let body;
        try{
            body = await submitOfflineDonationResponse.json();
        }
        catch(e){}
        if(submitOfflineDonationResponse && submitOfflineDonationResponse.ok){
            if(props.bottomView === 'updates'){
                props.setBottomView(formData.comment ? 'comments' : 'updates');
            }
            props.close();
        }
        else{
            const error = body?.error ? body.error : 'Offline donation submission failed';
            setErrorObject((prevState) => ({...prevState, apiError: error}));
        }
        setSubmissionInProgress(false);
    };

    return (
        <div className={styles.modal}>
            <div className={styles.container}>
                <div className={styles.header}>
                    Add offline donations
                </div>
                <img className={styles.close} src={close} alt="Close" onClick={props.close}/>
                <form className={styles.form} onSubmit={submit}>
                    <FormDonateMoneyInput className={styles.amountInput} value={formData.amount} update={updateDonationAmount} error={errorObject.amount}/>
                    <FormInput className={styles.input} label="Display name" type="text" placeholder="Optional"
                               value={formData.displayName} update={(event) => setFormData({...formData, displayName: event.target.value})}/>
                    {
                        errorObject.apiError && (
                            <FormError error={errorObject.apiError}/>
                        )
                    }
                    <div className={classNames(styles.buttons, {[styles.buttonsApiError]: errorObject.apiError})}>
                        <Button className={styles.button} text="Cancel" onClick={props.close}/>
                        <FormButton className={styles.button} style={{marginLeft: 'auto'}} text="Add" disabled={submissionInProgress}/>
                    </div>
                </form>
            </div>
        </div>
    )
};

export default OfflineDonateModal;